import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'vb-font-selector',
  templateUrl: './font-selector.component.html',
  styleUrls: ['./font-selector.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FontSelectorComponent),
      multi: true
    }
  ],
  standalone: false  //NOSONAR
})
export class FontSelectorComponent {
  @Input() disableField = false;
  @Input() currNodeType: any = null;
  private modelValue: any;
  private onChange: (m: any) => void;
  private onTouched: (m: any) => void;
  selectedFontFamily: any;
  defaultFontFamily: any = { name: 'Poppins', code: 'Poppins' };
  fontFamilies: any[] = [
    { name: 'Poppins', code: 'Poppins' },
    { name: 'Helvetica', code: 'Helvetica' },
    { name: 'Roboto', code: 'Roboto' },
    { name: 'Open Sans', code: 'Open Sans' },
    { name: 'Montserrat', code: 'Montserrat' },
    { name: 'Lato', code: 'Lato' }
  ];

  get model() {
    return this.modelValue;
  }

  writeValue(value: any): void {
    this.setValue(value);
    this.modelValue = value;
    if (this.currNodeType === 'appTitle' || this.currNodeType === 'APP_NAME') {
      this.disableField = true;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  set(value: any) {
    this.modelValue = value;
    this.onChange(this.modelValue);
  }
  setValue(value) {
    this.selectedFontFamily = value === null ? this.defaultFontFamily : value;
  }
  setValueToForm() {
    this.modelValue = this.selectedFontFamily;
    this.onChange(this.modelValue);
  }
}
